import { render, staticRenderFns } from "./mainbox.vue?vue&type=template&id=dc901ff6&scoped=true&"
import script from "./mainbox.vue?vue&type=script&lang=js&"
export * from "./mainbox.vue?vue&type=script&lang=js&"
import style0 from "./mainbox.vue?vue&type=style&index=0&id=dc901ff6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc901ff6",
  null
  
)

export default component.exports